import { Middleware } from 'openapi-fetch'

/**
 * Authorization header value or a function that returns a promise resolving to the authorization header value.
 */
export type AuthorizationMiddlewareOptions = string | (() => Promise<string>)

/**
 * openapi-fetch client middleware for adding an Authorization header to requests.
 */
export const openApiFetchAuthMiddleware = (authorization: AuthorizationMiddlewareOptions): Middleware => {
  const getToken = typeof authorization === 'string' ? async () => authorization : authorization

  return {
    onRequest: async ({ request }) => {
      request.headers.set('Authorization', await getToken())
      return request
    },
  }
}
